import React from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
// import "swiper/css/pagination";

import "../../../Swiper/style.css";

// import required modules
import { Pagination, Autoplay } from "swiper";
import Prods from "./Prods";

export default function PopularSwiper() {
  return (
    <>
      <Swiper
        slidesPerView={1}
        // spaceBetween={10}
        autoplay={{
          delay: 2000,
          disableOnInteraction: false,
        }}
        // pagination={{
        //   clickable: true,
        // }}
        breakpoints={{
          "@0.00": {
            slidesPerView: 1,
            spaceBetween: 3,
          },
          "@0.75": {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          "@1.00": {
            slidesPerView: 3,
            spaceBetween: 40,
          },
          "@1.50": {
            slidesPerView: 4,
            spaceBetween: 50,
          },
        }}
        modules={[Pagination, Autoplay]}
        scrollbar={{ el: ".swiper-scrollbar" }}
        className="mySwiper"
      >
        {[...Array(9)].map((elem, index) => (
          <div className="mx-20" key={elem + index}>
            <SwiperSlide>
              <Prods />
            </SwiperSlide>
          </div>
        ))}
      </Swiper>
    </>
  );
}
